import { WorkflowTriggerTypes } from 'src/app/models/RestApiCaller/Enums/workflow-trigger-types';
import { BaseTriggerData } from './base-trigger-data';

/**
 * Représente les données du trigger de 'Date atteinte'.
 */
export class DateReachedTriggerData extends BaseTriggerData {
    /**
     * Id de l'attribut contenant la date de reference.
     */
    public attributeId: number;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowTriggerTypes.DateReached);
    }

    /**
     * Retourne une copie d'une instance de DateReachedTriggerData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: DateReachedTriggerData) {
        if (!!other) {
            const instance = new DateReachedTriggerData();
            instance.attributeId = other.attributeId;
            instance.type = other.type;

            return instance;
        } else {
            return null;
        }
    }
}
